import { APIS } from '@/constants';
import axios from 'axios';

const permissionsApi = {
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestPermissionList(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      method: 'get',
      baseURL: APIS.BASE_URL.PERMISSIONS,
      headers,
    });
  },
};

export default permissionsApi;
